import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {
  goToPage,
  setIsSubmit,
  setIsValid,
  changeHandler,
  validateHandler,
  initRules,
  setIsCallBackConfirm,
  initValidation,
  openWorkOrder,
} from '../cellcomEnergySlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../Shared/TextInput/TextInput';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import PopUp from '../../../Shared/Popup/PopUp';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';

const LeadPage = (props) => {
  const [isDisplayPopup, setIsDisplayPopup] = useState(false);

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.initRules();
    }
    props.initValidation();
  }, []);

  useEffect(() => {
    if (props.isSubmit) {
      handleOnSubmit();
    }
  }, [props.isSubmit]);

  return (
    <div className='cellcom-energy-page-wrapper'>
      <div className='cellcom-energy-page'>
        <div className='gray-container'>
          <div className='lead-form-wrapper'>
            {props.hasCellcomEnergy ? (
              <div>
                <div className='lead-title'>
                  נראה שאנחנו בכיוון הנכון <br />
                  רק עוד דבר אחרון (וקצת מאתגר)
                </div>
                <div className='lead-text'>
                  נצטרך לוודא
                  <a id='display-cellcom-energy-popover' href='javascript:void(0)' onClick={handleDisplayPopup}>
                    שהמונה שלך חכם
                  </a>
                  <br />
                  לאחר מילוי הפרטים הבאים, אנו נוודא שהינכם זכאים לנייד את חשבון החשמל שלכם אלינו
                  <PopUp showPopUp={isDisplayPopup} onClose={() => handleClosePopup()} className='cellcom-energy-popup'>
                    <div className='cellcom-energy-popup-wrapper'>
                      <div className='title-wrapper'> תוכלו למצוא את מספר החוזה בחלק המסומן בתמונה </div>
                      <div className='image-wrapper'>
                        <Image src={require('../images/popup-with-mark.svg')} />
                      </div>
                    </div>
                  </PopUp>
                </div>
              </div>
            ) : (
              <div>
                <div className='lead-title'>טוב לצערנו עדין לא הגענו אליך</div>
                <div className='lead-text'>
                  רוצים שניצור אתכם קשר כשהכתובת שלכם תחובר למונה חכם <br />
                  מוזמנים להשאיר פה פרטים ונהיה בקשר בעתיד
                </div>
              </div>
            )}

            <div className='lead-form'>
              {props.hasCellcomEnergy && (
                <>
                  <div className='field-wrapper'>
                    <div className='field-remark'>
                      איפה רואים את
                      <a href='javascript:void(0)' onClick={handleDisplayPopup}>
                        מספר החוזה?
                      </a>
                    </div>
                    <TextInput
                      error={props.form.errors.contractNumber}
                      placeholder='מספר חוזה'
                      id='contractNumber'
                      name='contractNumber'
                      type='tel'
                      maxLength='30'
                      autoComplete='off'
                      value={props.form.contractNumber}
                      onChange={(e) => props.changeHandler({value: e.target.value, field: 'contractNumber'})}
                      required='required'
                    />
                  </div>

                  <div className='field-wrapper'>
                    <TextInput
                      error={props.form.errors.counterNumber}
                      placeholder='מספר מונה'
                      id='counterNumber'
                      name='counterNumber'
                      type='tel'
                      maxLength='30'
                      autoComplete='off'
                      value={props.form.counterNumber}
                      onChange={(e) => props.changeHandler({value: e.target.value, field: 'counterNumber'})}
                      required='required'
                    />
                  </div>
                </>
              )}

              <div className='field-wrapper'>
                <TextInput
                  error={props.form.errors.firstName}
                  placeholder='שם פרטי'
                  id='firstName'
                  name='firstName'
                  type='text'
                  maxLength='30'
                  autoComplete='off'
                  value={props.form.firstName}
                  onChange={(e) => props.changeHandler({value: e.target.value, field: 'firstName'})}
                  required='required'
                />
              </div>

              <div className='field-wrapper'>
                <TextInput
                  error={props.form.errors.lastName}
                  placeholder='שם משפחה'
                  id='lastName'
                  name='lastName'
                  type='text'
                  maxLength='30'
                  autoComplete='off'
                  value={props.form.lastName}
                  onChange={(e) => props.changeHandler({value: e.target.value, field: 'lastName'})}
                  required='required'
                />
              </div>

              <div className='field-wrapper'>
                <TextInput
                  error={props.form.errors.email}
                  placeholder='דואר אלקטרוני'
                  id='email'
                  name='email'
                  type='email'
                  maxLength='30'
                  autoComplete='off'
                  value={props.form.email}
                  onChange={(e) => props.changeHandler({value: e.target.value, field: 'email'})}
                  required='required'
                />
              </div>

              <div className='field-wrapper'>
                <TextInput
                  error={props.form.errors.phone}
                  placeholder='נייד'
                  id='phone'
                  name='phone'
                  type='tel'
                  maxLength='10'
                  autoComplete='off'
                  value={props.form.phone}
                  onChange={(e) => props.changeHandler({value: e.target.value, field: 'phone'})}
                  required='required'
                />
              </div>

              <div className='field-wrapper'>
                <CheckBox
                  checked={props.form.isCallBackConfirm}
                  id='checkBoxCallBackConfirm'
                  onCheck={(e) => props.setIsCallBackConfirm(true)}
                  onUncheck={(e) => props.setIsCallBackConfirm(false)}
                  onChange={(e) => props.changeHandler({value: e.target.checked, field: 'isCallBackConfirm'})}
                  error={props.form.errors.isCallBackConfirm}
                  label='אישור משפטי לחזרה ללקוח'></CheckBox>
              </div>
            </div>
          </div>
        </div>

        <div className='btn-wrapper'>
          <BtnSubmit text={'שלח'} onclick={handleLeadPageClick} />
        </div>
      </div>
    </div>
  );

  function handleLeadPageClick() {
    props.validateHandler();
    props.setIsSubmit(true);
  }

  function handleOnSubmit() {
    if (props.form.valid == true) {
      let leadData = {
        firstName: props.form.firstName,
        lastName: props.form.lastName,
        email: props.form.email,
        phone: props.form.phone,
        fuType: props.hasCellcomEnergy ? props.fuTypeAddressSupported : props.fuTypeAddressNotSupported,
      };

      if (props.hasCellcomEnergy) {
        leadData.contractNumber = props.form.contractNumber;
        leadData.counterNumber = props.form.counterNumber;
      }

      props.openWorkOrder(leadData);
    }
    props.setIsSubmit(false);
    props.setIsValid(false);
  }

  function handleDisplayPopup() {
    setIsDisplayPopup(true);
  }
  function handleClosePopup() {
    setIsDisplayPopup(false);
  }
};

const mapStateToProps = (state) => {
  return {
    page: state.cellcomEnergyBlock.page,
    fuTypeAddressSupported: state.cellcomEnergyBlock.fuTypeAddressSupported,
    fuTypeAddressNotSupported: state.cellcomEnergyBlock.fuTypeAddressNotSupported,
    isSubmit: state.cellcomEnergyBlock.isSubmit,
    isValid: state.cellcomEnergyBlock.isValid,
    hasCellcomEnergy: state.cellcomEnergyBlock.hasCellcomEnergy,
    form: state.cellcomEnergyBlock.form,
  };
};

const mapDispatchToProps = {
  goToPage,
  setIsSubmit,
  setIsValid,
  changeHandler,
  validateHandler,
  initRules,
  setIsCallBackConfirm,
  initValidation,
  openWorkOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadPage);
